import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow errors originating from browser extensions (e.g. MetaMask, Chrome
// extensions) so the React dev overlay does not obscure VENTREX with an
// "Uncaught runtime errors" panel that has nothing to do with the app.
const isExtensionError = (source) => {
  if (!source) return false;
  const value = String(source);
  return value.startsWith("chrome-extension://") ||
    value.startsWith("moz-extension://") ||
    value.startsWith("safari-web-extension://");
};

window.addEventListener(
  "error",
  (event) => {
    if (isExtensionError(event.filename) || isExtensionError(event?.error?.stack)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    if (isExtensionError(reason?.stack) || isExtensionError(reason?.fileName)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
